import ajax from "@/lib/ajax";

// 查询新入院患者列表
export async function QueryPDNewWinList(payload: any) {
    let res = await ajax.post(`/api/services/app/PDNewWin/QueryPDNewWinList`, payload);
    return res.data.result;
}


// WEBPACK FOOTER //
// ./src/api/pdNewWin/index.ts